<template>
  <div
    :hidden="
      isKnownUser &&
      message.buttons.length === 1 &&
      message.buttons[0].trigger_flow === 'login_and_signup'
    "
  >
    <span class="icon-message icon-action" :style="{ ...computedIconColors, padding: '10px' }">
      <p style="margin: 0 0 10px" v-html="displayText"></p>
      <div class="button-wrap">
        <component
          :is="button.trigger_flow === 'url' ? 'a' : 'button'"
          v-for="button in displayButtons"
          v-bind="
            button.trigger_flow === 'url' && button.url
              ? { href: button.url, target: '_blank' }
              : { type: 'button' }
          "
          class="icon-message-button"
          :style="buttonStyle"
          :hidden="button.trigger_flow === 'login_and_signup' && isKnownUser"
          @click="action(button)"
        >
          {{ button.button_text }}
        </component>
      </div>
    </span>
    <slot name="close"></slot>
  </div>
</template>

<script>
import Plain from './Plain.vue'
import { lineBreaks , isSafari } from 'Utilities'
import { useIconMessageStore } from 'Store/icon-message'
import { useChatStore } from 'Store/chat'
import { useAppStore } from 'Store/app'
import { useUserStore } from 'Store/user'
import { useSettingsStore } from 'Store/settings'

export default {
  extends: Plain,

  setup() {
    return {
      iconMessageStore: useIconMessageStore(),
      chatStore: useChatStore(),
      appStore: useAppStore(),
      userStore: useUserStore(),
      settingsStore: useSettingsStore()
    }
  },

  computed: {
    displayText() {
      return lineBreaks(this.message.text)
    },
    isKnownUser() {
      return this.userStore.isKnownUser
    },
    displayButtons() {
      return this.message.buttons.filter((button) => {
        if (button.trigger_flow === 'url') {
          return button.url && button.button_text
        }
        return button.button_text
      })
    },
    buttonStyle() {
      return {
        textAlign: 'center',
        backgroundColor: this.message.button_style
          ? this.message.button_style.includes('fill')
            ? this.message.button_background_color
            : 'transparent'
          : this.message.textColor,
        borderColor: this.message.button_background_color || this.message.textColor,
        color: this.message.button_style
          ? this.message.button_style.includes('fill')
            ? this.message.button_text_color
            : this.message.button_background_color
          : this.message.backgroundColor,
        borderRadius: this.message.button_style
          ? this.message.button_style.includes('rounded')
            ? '20px'
            : '5px'
          : '5px'
      }
    }
  },

  methods: {
    action(button) {
      const messagePayload = { ...this.message, buttons: [button] }
      this.$gtag.recordIconMessageClicked(messagePayload)

      if (button.trigger_flow === 'room_reservation') {
        this.$gtag.recordIconActionRoomReservationTriggered(messagePayload)
      }

      if (button.trigger_flow === 'url') {
        this.trackMetrics('click')
        return
      }

      if (button.trigger_flow === 'login_and_signup') {
        this.appStore.setAutoMessageAuthType('icon_auto_message')
        this.appStore.setAutoMessageAuthId(this.message.id)
      }

      if (
        button.trigger_flow === 'booking_widget' &&
        isSafari() &&
        this.settingsStore.isBWOpenInNewTab
      ) {
        window.safariBwWindow = window.open('about:blank')
      }

      this.openChat()
      this.chatStore.sendIconAutoMessage(messagePayload)
      this.trackMetrics('click')
    }
  }
}
</script>
